import { styled } from '@mui/system'

export const Wrapper = styled('div')`
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    height: 100%;
    color: var(--text-color-dark);

    i.separator {
        display: block;
        margin-block: 12px;
        @include item-border($size: 1px, $color: var(--color-dark-400));
    }
`
export const Header = styled('div')`
    display: flex;
    align-items: center;
    padding: 36px 0;
    border-bottom: 4px solid var(--color-greys-50);
`

export const Content = styled('div')`
    gap: 24px;
    padding: 36px 0;
    height: 100%;
`

export const Footer = styled('div')`
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 36px 0;
    border-top: 4px solid var(--color-greys-50);
`
